var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKeyAccent600(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.2504 11.25L28.5004 6M31.5004 3L28.5004 6L31.5004 3ZM17.0854 17.415C17.8599 18.1792 18.4756 19.0891 18.897 20.0922C19.3185 21.0953 19.5373 22.1719 19.541 23.2599C19.5446 24.348 19.333 25.426 18.9183 26.432C18.5036 27.4379 17.894 28.3518 17.1246 29.1212C16.3553 29.8906 15.4413 30.5002 14.4354 30.9149C13.4294 31.3296 12.3514 31.5412 11.2634 31.5375C10.1753 31.5339 9.09873 31.3151 8.0956 30.8936C7.09247 30.4722 6.18261 29.8565 5.41841 29.082C3.91561 27.526 3.08405 25.4421 3.10285 23.2789C3.12165 21.1158 3.98929 19.0466 5.51891 17.517C7.04853 15.9874 9.11773 15.1197 11.2809 15.1009C13.444 15.0821 15.5279 15.9137 17.0839 17.4165L17.0854 17.415ZM17.0854 17.415L23.2504 11.25L17.0854 17.415ZM23.2504 11.25L27.7504 15.75L33.0004 10.5L28.5004 6L23.2504 11.25Z",
    stroke: "#648CE6",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyAccent600);
export default __webpack_public_path__ + "static/media/key-accent600.c643630e0a674709bd704817ca263fed.svg";
export { ForwardRef as ReactComponent };